<template>
  <div class="syntry-logo" :class="`syntry-logo--${size}`">
    <img src="/assets/logo/syntry-mark.svg" alt="" class="syntry-logo__mark" aria-hidden="true" />
    <div class="syntry-logo__text">
      <span class="syntry-logo__wordmark">Syntry</span>
      <span class="syntry-logo__powered">
        by <strong>ERPat System</strong>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: 'sm' | 'md' | 'lg';
  }>(),
  { size: 'md' },
);
</script>

<style scoped lang="scss">
.syntry-logo {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-1);
  user-select: none;

  &__mark {
    display: block;
  }

  &__text {
    display: flex;
    flex-direction: column;
    /* stretch (not flex-start) so the tagline spans the wordmark's width */
    align-items: stretch;
    line-height: 1;
  }

  /* --syntry-mark, not --syntry-primary: the wordmark is the Syntry product
     identity and must keep its teal even when a tenant brand color repaints
     the primary tokens (src/theme/brand-color.ts). */
  &__wordmark {
    font-weight: 800;
    color: var(--syntry-mark);
    letter-spacing: -0.01em;
  }

  /* The tagline is tracked out so it ends flush with the wordmark above it.
     Per-size letter-spacing does the bulk of the work (measured against Inter);
     text-align-last closes whatever tracking can't cover when the font falls
     back to the system stack, and the negative right margin cancels the
     trailing letter-space so the last glyph — not the gap after it — lands on
     the wordmark's right edge. */
  &__powered {
    margin-top: 2px;
    font-size: 9px;
    font-weight: 500;
    color: var(--syntry-text-muted);
    text-align: justify;
    text-align-last: justify;

    strong {
      color: var(--erpat-primary);
      font-weight: 700;
    }
  }

  &--sm {
    .syntry-logo__mark { width: 48px; height: 48px; }
    .syntry-logo__wordmark { font-size: 24px; }
    .syntry-logo__powered { font-size: 9px; letter-spacing: 0.035em; margin-right: -0.035em; }
  }

  &--md {
    .syntry-logo__mark { width: 64px; height: 64px; }
    .syntry-logo__wordmark { font-size: 39px; }
    .syntry-logo__powered { font-size: 12px; letter-spacing: 0.15em; margin-right: -0.15em; }
  }

  &--lg {
    .syntry-logo__mark { width: 80px; height: 80px; }
    .syntry-logo__wordmark { font-size: 48px; }
    .syntry-logo__powered { font-size: 15px; letter-spacing: 0.14em; margin-right: -0.14em; }
  }
}
</style>
